import { request } from 'utils/requests'

// Várias partes da tela pedem a lista ao mesmo tempo: aproveita a chamada em andamento.
let emAndamento = null

// Usa o cliente HTTP padrão com interceptor de autenticação,
// evitando problemas de cabeçalho/token em sessões recém-logadas.
const listCollaborators = async () => {
  if (!emAndamento) {
    emAndamento = request.get('/collaborator/listUsers').finally(() => { emAndamento = null })
  }
  return emAndamento
}

export default listCollaborators
